import React from "react";

const Home = () => {
  return (
    <>
      <div className="Home">
        <h1 className="welcomw_h1">Welcome</h1>
      </div>
    </>
  );
};

export default Home;
